/**
 * Application Routes
 * Zentrale Definition aller Routes
 */

export const ROUTES = {
  home: '/',
  test: '/test',
  results: '/results',
  email: '/email',
  about: '/about',
  contact: '/contact',
  faq: '/faq',
  privacy: '/privacy',
  terms: '/terms',
} as const;

export type Route = typeof ROUTES[keyof typeof ROUTES];





